import Skeleton from '@mui/material/Skeleton';
import { DatagridSkeleton } from 'shared/react-admin/Datagrids';

import { BoxStyled } from './RefundChargebackReportSummary.styled';
import { RefundChargebackReportSummaryDropdownStyled } from './RefundChargebackReportSummaryDropdown/RefundChargebackReportSummaryDropdown.styled';

export const RefundChargebackReportSummarySkeleton: React.FC = () => (
  <BoxStyled>
    <RefundChargebackReportSummaryDropdownStyled isOpen>
      <Skeleton height={20} variant="rounded" width={360} />
      <Skeleton height={24} sx={{ marginRight: '8px' }} variant="circular" width={24} />
    </RefundChargebackReportSummaryDropdownStyled>
    <DatagridSkeleton columnsCount={10} />
  </BoxStyled>
);
